// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2jcDE","tab":"Tabs_tab__2zOZG","tabActive":"Tabs_tabActive__33ysr"};